import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const PathContext = createContext({});

export function PathContextProvider ({ children }) {
  const [path, setPath] = useState('PathContext');
  const value = useMemo(() => ({ path, setPath }), [path]);
  return (
    <PathContext.Provider value={value}>
      {children}
    </PathContext.Provider>
  );
}

PathContextProvider.propTypes = {
  children: PropTypes.object.isRequired,
};

export default PathContext;
